export default __webpack_public_path__ + "static/media/manage-swaps.255416a3.png";